var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0404 4.70357L11.0417 4.68547V4.66732C11.0417 4.28054 11.1953 3.90961 11.4688 3.63612C11.7423 3.36263 12.1132 3.20898 12.5 3.20898C12.8868 3.20898 13.2577 3.36263 13.5312 3.63612L13.8772 3.29009L13.5312 3.63612C13.8047 3.90961 13.9583 4.28054 13.9583 4.66732V4.68547L13.9597 4.70357C13.9648 4.77396 13.9648 4.84463 13.9597 4.91503L13.9304 5.3168L14.3168 5.43083C16.9297 6.202 18.8542 8.63505 18.8542 11.5215V17.3965V17.6036L19.0006 17.75L20.8125 19.5619V19.834H4.1875V19.5619L5.99939 17.75L6.14583 17.6036V17.3965V11.5215C6.14583 8.63505 8.07026 6.202 10.6832 5.43083L11.0696 5.3168L11.0404 4.91502C11.0352 4.84463 11.0352 4.77396 11.0404 4.70357ZM11.4688 22.3443C11.3171 22.1926 11.2022 22.0109 11.1301 21.8131H13.8699C13.7978 22.0109 13.6829 22.1926 13.5312 22.3443C13.2577 22.6178 12.8868 22.7715 12.5 22.7715C12.1132 22.7715 11.7423 22.6178 11.4688 22.3443Z",
    fill: "#C7C9C7",
    stroke: "#C7C9C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.aae752f1.svg";
export { ForwardRef as ReactComponent };